import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 300px;
  border-right: 5px solid #c45634;
  /* border-radius: 5px; */
  /* padding-right: 50px; */
`;
